import BlockIcon from '@mui/icons-material/Block';
import HomeIcon from '@mui/icons-material/Home';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { ExternalLink } from '../atoms/ExternalLink/ExternalLink';
import { Logo } from '../atoms/Icon/Logo';
import { CenterLayout } from '../layouts/CenterLayout';

const styles: Record<string, SxProps<Theme>> = {
  paper: {
    px: 5,
    py: 5,
    backgroundColor: 'background.paper',
    borderRadius: 3,
    maxWidth: 640,
    mx: 'auto',
    textAlign: 'center',
  },
  headline: {
    fontWeight: 'bold',
    mb: 3,
    color: 'error.dark',
  },
  ipSection: {
    mt: 2,
    mb: 4,
  },
  ipLabel: {
    fontSize: '0.9rem',
    color: 'text.secondary',
  },
  ipValue: {
    fontSize: '1.4rem',
    fontWeight: 600,
    color: 'primary.main',
    mt: 0.5,
    textAlign: 'center',
    wordBreak: 'break-all',
    width: '100%',
  },
  supportText: {
    fontSize: '0.95rem',
    color: 'text.secondary',
    mt: 3,
  },
  homeButton: {
    mt: 5,
    px: 4,
    py: 1.5,
    fontSize: '1rem',
    borderRadius: 3,
    boxShadow: 2,
    textTransform: 'none',
  },
};

export const IpLimitedPage: FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryIp = searchParams.get('ip');

  return (
    <CenterLayout>
      <Paper sx={styles.paper} elevation={6}>
        <Logo />
        <Typography
          variant="h5"
          sx={styles.headline}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
        >
          <BlockIcon color="error" fontSize="large" />
          アクセスが拒否されました
        </Typography>

        <Typography>
          ご利用のグローバルIPアドレスからの
          <br />
          アクセスは制限されています。
        </Typography>

        <Box sx={styles.ipSection}>
          <Fade in={true}>
            <Box>
              <Typography sx={styles.ipLabel}>接続元IPアドレス</Typography>
              {queryIp ? (
                <Typography sx={styles.ipValue}>{queryIp}</Typography>
              ) : (
                <Typography sx={styles.ipValue}>
                  IPアドレスの取得に失敗しました
                </Typography>
              )}
            </Box>
          </Fade>
        </Box>

        <Typography sx={styles.supportText}>
          詳しくは{' '}
          <ExternalLink href="https://clarislink-support.com">
            こちら
          </ExternalLink>
          をご覧ください。
        </Typography>

        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          color="primary"
          startIcon={<HomeIcon />}
          sx={styles.homeButton}
        >
          トップに戻る
        </Button>
      </Paper>
    </CenterLayout>
  );
};
